import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './faqs.css'; // We'll define custom styles here

const FAQs = () => {
  const faqs = [
    {
      question: 'What is Loan on tip, and how does it work?',
      answer: 'Loanontip is a digital lending platform by RRYO Private Limited that offers instant personal loans in partnership with ACG Leasing Limited (RBI-registered NBFC).',
    },
    {
      question: 'Is my Data safe with Loan on Tip ?',
      answer: 'Yes, your data is 100% secure and protected using bank-grade encryption and RBI-compliant privacy standards.',
    },
    
  ];

  return (
    <section className="faq-section py-3">
      <div className="container">
        <h2 style={{ color: '#052daa', textAlign: 'center', marginBottom: '2rem' }}>Frequently Asked Questions</h2>
        <div className="accordion" id="faqAccordion">
          {faqs.map((faq, index) => (
            <div className="accordion-item border-0 mb-3 shadow-sm" key={index}>
              <h2 className="accordion-header" id={`heading${index}`}>
                <button
                  className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${index}`}
                  aria-expanded={index === 0 ? 'true' : 'false'}
                  aria-controls={`collapse${index}`}
                >
                  {faq.question}
                </button>
              </h2>
              <div
                id={`collapse${index}`}
                className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                aria-labelledby={`heading${index}`}
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQs;
